import { createFileRoute } from "@tanstack/react-router";
import { StaffNotesInbox } from "@/components/app/community-notes/staff-notes-inbox";
import { PageHeader } from "@/components/app/shell/page-header";

export const Route = createFileRoute("/_authenticated/community/notes")({
  component: NotesPage,
});

/** Notes from families waiting to be read to residents, for the shift. */
function NotesPage() {
  return (
    <>
      <PageHeader title="Notes from family" />
      <StaffNotesInbox />
    </>
  );
}
